import React, { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import './NewsPageAdmin.css';
import NavBarAdmin from "../NavBarAdmin";
import config from '../config/config';

const API_URL = `${config.apiUrl2}/api/news`;
const SESSION_TIMEOUT = 10 * 60 * 1000; // 5 минут

export default function NewsPageAdmin() {
    const navigate = useNavigate();
    const [newsList, setNewsList] = useState([]);
    const [formData, setFormData] = useState({
        id: null,
        newsContent: "",
    });
    const [selectedFile, setSelectedFile] = useState(null);
    const [isEditing, setIsEditing] = useState(false);

    // ✅ Проверка авторизации и времени сессии
    useEffect(() => {
        const isAuth = localStorage.getItem('adminAuth');
        const loginTime = localStorage.getItem('loginTime');

        if (isAuth && loginTime) {
            const diff = Date.now() - Number(loginTime);
            if (diff > SESSION_TIMEOUT) {
                // Сессия истекла
                localStorage.removeItem('adminAuth');
                localStorage.removeItem('loginTime');
                alert('Сессия истекла, пожалуйста, войдите заново.');
                navigate('/panel/admin-login');
            }
        } else {
            // Не авторизован
            navigate('/panel/admin-login');
        }
    }, [navigate]);

    // 📌 Загрузка новостей
    useEffect(() => {
        loadNews();
    }, []);

    const loadNews = async () => {
        try {
            const res = await fetch(API_URL);
            const data = await res.json();
            setNewsList(data);
        } catch (err) {
            console.error("Ошибка загрузки новостей:", err);
        }
    };

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleFileChange = (e) => {
        setSelectedFile(e.target.files[0]);
    };

    // 📌 Создание новости
    const handleCreate = async () => {
        const formDataToSend = new FormData();
        formDataToSend.append("newsContent", formData.newsContent); // 👈 исправлено
        if (selectedFile) {
            formDataToSend.append("file", selectedFile);
        }

        await fetch(API_URL, {
            method: "POST",
            body: formDataToSend,
        });

        resetForm();
        loadNews();
    };

// 📌 Обновление новости
    const handleUpdate = async () => {
        const formDataToSend = new FormData();
        formDataToSend.append("newsContent", formData.newsContent); // 👈 одинаково
        if (selectedFile) {
            formDataToSend.append("file", selectedFile);
        }

        await fetch(`${API_URL}/${formData.id}`, {
            method: "PUT",
            body: formDataToSend,
        });

        setIsEditing(false);
        resetForm();
        loadNews();
    };

    // 📌 Удаление новости
    const handleDelete = async (id) => {
        await fetch(`${API_URL}/${id}`, { method: "DELETE" });
        loadNews();
    };

    // 📌 Редактирование новости
    const handleEdit = (news) => {
        setFormData({
            id: news.id,
            newsContent: news.newsContent,
        });
        setIsEditing(true);
        setSelectedFile(null);
    };

    const resetForm = () => {
        setFormData({ id: null, newsContent: "" });
        setSelectedFile(null);
    };

    return (
        <>
            <header className="header">
                <NavBarAdmin />
            </header>

            <div className="news-admin-container">
                <h1>Новости</h1>

                <div className="news-form">
                    <textarea
                        name="newsContent"
                        placeholder="Содержание"
                        value={formData.newsContent}
                        onChange={handleChange}
                    />

                    <input
                        type="file"
                        onChange={handleFileChange}
                    />

                    {isEditing ? (
                        <button className="btn btn-update" onClick={handleUpdate}>
                            Обновить новость
                        </button>
                    ) : (
                        <button className="btn btn-create" onClick={handleCreate}>
                            Создать новость
                        </button>
                    )}
                </div>

                <table className="news-table">
                    <thead>
                    <tr>
                        <th>ID</th>
                        <th>Содержание</th>
                        <th>Изображение</th>
                        <th>Дата</th>
                        <th>Действия</th>
                    </tr>
                    </thead>
                    <tbody>
                    {newsList.map((n) => (
                        <tr key={n.id}>
                            <td>{n.id}</td>
                            <td>{n.newsContent}</td>
                            <td>
                                {n.img2 && (
                                    <img
                                        className="news-imageeeww"
                                        src={n.img2}
                                        alt="news"
                                    />
                                )}
                            </td>
                            <td>{new Date(n.newsDate).toLocaleString()}</td>
                            <td>
                                <button className="btn btn-edit" onClick={() => handleEdit(n)}>
                                    Редактировать
                                </button>
                                <button className="btn btn-delete" onClick={() => handleDelete(n.id)}>
                                    Удалить
                                </button>
                            </td>
                        </tr>
                    ))}
                    </tbody>
                </table>
            </div>
        </>
    );
}
